// -----------------------------------------------------------------------------
// PLUGINS/LIFTABLE
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
import { elt, setClass } from "../util/dom";
import icons from "../util/icons";
export class Liftable {
    constructor(view, config) {
        this.view = view;
        this.lift = config.lift;
        this.sink = config.sink;
        this.active = config.active;
        this.liftElem = elt("span", {
            className: "df-ed-mu__lift",
            onclick: () => {
                this.lift(this.view.state, this.view.dispatch, this.view);
            }
        }, icons.chevronLeft("df-ed-mu__arrow-icon"));
        this.sinkElem = elt("span", {
            className: "df-ed-mu__sink",
            onclick: () => {
                this.sink(this.view.state, this.view.dispatch, this.view);
            }
        }, config.icon);
        this.dom = elt("div", {
            className: "df-ed-mu__liftable"
        }, this.liftElem, this.sinkElem);
    }
    update() {
        let liftEnabled = this.active(this.view.state) &&
            this.lift(this.view.state, null, this.view);
        let sinkEnabled = this.sink(this.view.state, null, this.view);
        setClass(this.liftElem, "df-ed-mu__lift--disabled", !liftEnabled);
        setClass(this.sinkElem, "df-ed-mu__sink--disabled", !sinkEnabled);
    }
    destroy() {
        this.dom.remove();
    }
}
